/**
 * Отправка заявки в существующий бэкенд RIS — ту же ручку, что использует
 * форма на текущем about.ris.promo. Оттуда заявка уходит письмом на почту
 * команды, отдельный почтовый сервис поднимать не нужно.
 *
 * Сайт деплоится на about.ris.promo — тот же origin, с которого этот запрос
 * ходит сегодня, поэтому CORS работает как сейчас. При переезде на другой
 * домен бэкенд должен будет разрешить новый origin.
 *
 * req-xid-token и Authorization в оригинале — один и тот же свежий uuid v4
 * на загрузку страницы: это трассировочный идентификатор запроса, не секрет.
 */
const API_URL = 'https://api.ris.promo/services/landing_rispromo/ris_connect'

const requestId = crypto.randomUUID()

interface LeadPayload {
  email: string
  /** Бэкенд ждёт полный набор полей формы. В модалке собираем только почту,
   *  остальное уходит пустым — форма «Напомнить позже» короткая намеренно. */
  fio: string
  phone: string
  site: string
}

export async function submitLead(email: string): Promise<boolean> {
  const payload: LeadPayload = { email: email.trim(), fio: '', phone: '', site: '' }

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        // Переводит отказы бэкенда в формат RFC 9457
        Accept: 'application/problem+json, application/json',
        'req-xid-token': requestId,
        Authorization: requestId,
      },
      body: JSON.stringify(payload),
    })
    const data: unknown = await response.json().catch(() => null)
    return response.ok && (data as { success?: boolean } | null)?.success === true
  } catch {
    return false
  }
}
